import { render, staticRenderFns } from "./HotelShare.vue?vue&type=template&id=629975e1"
import script from "./HotelShare.vue?vue&type=script&lang=js"
export * from "./HotelShare.vue?vue&type=script&lang=js"
import style0 from "./HotelShare.vue?vue&type=style&index=0&id=629975e1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports